const ENDPOINT = process.env.REACT_APP_API_ENDPOINT || '/'

export const clippingsApi = {
    async fetchClippings(filter, offset, limit = 20) {
        try {
            const response = await fetch(`${ENDPOINT}clippings/?${filter}&offset=${offset}`, {
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
                })
            })
            const data = await response.json()

            if (!response.ok) {
                throw new Error('failed to fetch clippings')
            }

            return data
        } catch (error) {
            console.error('error fetching clippings:', error)
            throw error
        }
    },

    async deleteClipping(clippingId) {
        try {
            const response = await fetch(`${ENDPOINT}clippings/${clippingId}`, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
                })
            })

            if (!response.ok) {
                throw new Error('failed to delete clipping')
            }

            return true
        } catch (error) {
            console.error('error deleting clipping:', error)
            throw error
        }
    },

    async toggleFavorite(clippingId, isFavorite) {
        try {
            const response = await fetch(`${ENDPOINT}clippings/${clippingId}`, {
                method: 'PATCH',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({ isFavorite })
            })

            if (!response.ok) {
                throw new Error('failed to toggle favorite')
            }

            return await response.json()
        } catch (error) {
            console.error('error toggling favorite:', error)
            throw error
        }
    },

    async uploadFile(file) {
        try {
            const formData = new FormData()
            formData.append('file', file)

            const response = await fetch(`${ENDPOINT}upload/`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
                }),
                body: formData
            })

            if (!response.ok) {
                throw new Error('failed to upload file')
            }

            return await response.json()
        } catch (error) {
            console.error('error uploading file:', error)
            throw error
        }
    },

    async fetchLabels(retries = 3) {
        try {
            const response = await fetch(`${ENDPOINT}labels`, {
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
                })
            })
            const data = await response.json()

            if (!response.ok) {
                throw new Error('failed to fetch labels')
            }

            if (data.labels === null && retries > 0) {
                return this.fetchLabels(retries - 1)
            }

            return data.labels || []
        } catch (error) {
            console.error('error fetching labels:', error)
            if (retries > 0) {
                return this.fetchLabels(retries - 1)
            }
            throw error
        }
    },

    async deleteLabel(labelName) {
        try {
            const response = await fetch(`${ENDPOINT}labels`, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({ Name: labelName })
            })

            if (!response.ok) {
                throw new Error('failed to delete label')
            }

            return await response.json()
        } catch (error) {
            console.error('error deleting label:', error)
            throw error
        }
    },

    async removeLabelFromClipping(labelName, clippingId) {
        try {
            const response = await fetch(`${ENDPOINT}clippings_labels`, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    Name: labelName,
                    ClippingID: clippingId
                })
            })

            if (!response.ok) {
                throw new Error('failed to remove label from clipping')
            }

            return await response.json()
        } catch (error) {
            console.error('error removing label from clipping:', error)
            throw error
        }
    },

    async deleteLabelCascade(labelName) {
        try {
            const response = await fetch(`${ENDPOINT}labels`, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    Name: labelName
                })
            })

            if (!response.ok) {
                throw new Error('failed to delete label cascade')
            }

            return await response.json()
        } catch (error) {
            console.error('error deleting label cascade:', error)
            throw error
        }
    },

    async deleteAllClippings() {
        try {
            const response = await fetch(`${ENDPOINT}clippings/all`, {
                method: 'DELETE',
                credentials: 'same-origin',
                headers: new Headers({
                    Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
                })
            })

            if (!response.ok) {
                throw new Error('failed to delete all clippings')
            }

            return true
        } catch (error) {
            console.error('error deleting all clippings:', error)
            throw error
        }
    },

    async fetchTTSVoices() {
        const response = await fetch(`${ENDPOINT}api/tts/voices`, {
            credentials: 'same-origin',
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`
            })
        })
        if (!response.ok) throw new Error('failed to fetch TTS voices')
        const data = await response.json()
        return data.voices || []
    },

    async fetchTTS(text, voiceId) {
        const response = await fetch(`${ENDPOINT}api/tts`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({
                Authorization: `Bearer ${localStorage.getItem('clippingsToken')}`,
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({ text, voice_id: voiceId })
        })
        if (response.status === 429) {
            const err = await response.json().catch(() => ({}))
            throw new Error(err.error || 'Daily TTS limit (500 characters) reached. Try again tomorrow.')
        }
        if (!response.ok) {
            const err = await response.json().catch(() => ({}))
            throw new Error(err.error || response.statusText)
        }
        return response.blob()
    }
} 